export default {
  watch: {
    track: {
      handler (value) {
        this.updateCube(value)
      },
      deep: true
    }
  },
  methods: {
    cubeComponents () {
      const track = this.track
      const audioElement = document.querySelector('audio')

      if (!AFRAME.components.cube) {
        AFRAME.registerComponent('cube', {
          init () {
            const cubeMesh = this.el.getObject3D('mesh')
            const cubeElement = document.querySelector('[cube]')

            if (track) {
              cubeElement.setAttribute('visible', true)
            }

            const artwork = new THREE.MeshBasicMaterial({
              map: new THREE.TextureLoader().load(
                track && track.image ? track.image : '/'
              )
            })
            const top = new THREE.MeshBasicMaterial({
              map: new THREE.TextureLoader().load('/dropsTop.png')
            })
            const bottom = new THREE.MeshBasicMaterial({
              map: new THREE.TextureLoader().load('/dropsBottom.png')
            })

            const pause = new THREE.MeshBasicMaterial({
              map: new THREE.TextureLoader().load('/Pause@3x.png')
            })
            const play = new THREE.MeshBasicMaterial({
              map: new THREE.TextureLoader().load('/Play@3x.png')
            })

            const cubeMaterials = [
              artwork,
              artwork,
              top,
              bottom,
              track ? pause : play,
              track ? pause : play
            ]

            cubeMesh.material = cubeMaterials

            this.el.addEventListener('click', (e) => {
              console.log('cube click')
              if (this.el.hasAttribute('animation')) {
                this.el.removeAttribute('animation')
                audioElement.pause()
                cubeMaterials[4] = play
                cubeMaterials[5] = play
              } else {
                const cubeAnimation = cubeElement.getAttribute('cube-animation')
                this.el.setAttribute('animation', cubeAnimation)
                cubeMaterials[4] = pause
                cubeMaterials[5] = pause

                const playPromise = audioElement.play()
                // In browsers that don’t yet support this functionality,
                // playPromise won’t be defined.
                if (playPromise !== undefined) {
                  playPromise
                    .then(function () {
                      // Automatic playback started!
                    })
                    .catch(function (error) {
                      debugger
                      // Automatic playback failed.
                      // Show a UI element to let the user manually start playback.
                    })
                }
              }
            })
          },
          remove () {
            delete AFRAME.components.cube
          }
        })
      }
    },
    updateCube (track) {
      const cubeElement = document.querySelector('[cube]')
      if (cubeElement) {
        const cubeMesh = cubeElement.getObject3D('mesh')
        const audioElement = document.querySelector('audio')

        const artwork = new THREE.MeshBasicMaterial({
          map: new THREE.TextureLoader().load(
            track && track.image ? track.image : '/dropsTop.png'
          )
        })
        const play = new THREE.MeshBasicMaterial({
          map: new THREE.TextureLoader().load('/Play@3x.png')
        })

        if (cubeMesh) {
          cubeMesh.material[0] = artwork
          cubeMesh.material[1] = artwork
        }

        if (track) {
          cubeElement.setAttribute('visible', true)
          if (track.provider) {
            audioElement.setAttribute(
              'src',
              track.provider === 'spotify'
                ? track.preview_url
                : track.stream_url
            )
          }
          const playPromise = audioElement.play()
          // In browsers that don’t yet support this functionality,
          // playPromise won’t be defined.
          if (playPromise !== undefined) {
            playPromise
              .then(function () {
                // Automatic playback started!
                const cubeAnimation = cubeElement.getAttribute('cube-animation')
                cubeElement.setAttribute('animation', cubeAnimation)
              })
              .catch(function (error) {
                debugger
                // Automatic playback failed.
                // Show a UI element to let the user manually start playback.
              })
          }
        } else {
          cubeElement.setAttribute('visible', false)
          cubeElement.removeAttribute('animation')
          if (cubeMesh) {
            cubeMesh.material[4] = play
            cubeMesh.material[5] = play
          }
        }
      }
    }
  }
}
